module.exports = __webpack_public_path__ + "img/dashboard-projects.8ceaa41c.svg";